import React from 'react'
import Button from '../../../components/ui/Button'
import Icon from '../../../components/AppIcon'
import CustomerPhoto from './CustomerPhoto'

export default function TransactionCompletion({
  transactionId, transactionNumber, payout, customerPhoto, customerPhotoSkipped,
  onPreview, onPrint, onNewTransaction,
}) {
  return (
    <div className="space-y-6">
      <div className="text-center py-6">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="CheckCircle" size={32} className="text-primary" />
        </div>
        <h3 className="text-xl font-bold text-foreground mb-1">Transaction Complete</h3>
        <p className="text-lg font-medium text-primary mb-3">{transactionNumber}</p>
        <p className="text-sm text-foreground">Payout</p>
        <p className="text-4xl font-bold text-foreground">${Number(payout || 0).toFixed(2)}</p>
      </div>

      <CustomerPhoto src={customerPhoto} skipped={customerPhotoSkipped} />

      <div className="grid grid-cols-2 gap-3">
        <Button variant="outline" size="lg" iconName="Eye" iconPosition="left" disabled={!transactionId} onClick={onPreview}>
          Preview
        </Button>
        <Button variant="outline" size="lg" iconName="Printer" iconPosition="left" disabled={!transactionId} onClick={onPrint}>
          Print
        </Button>
      </div>
      <Button variant="default" size="lg" className="w-full" onClick={onNewTransaction} iconName="Plus" iconPosition="left">
        New Transaction
      </Button>
    </div>
  )
}
